import { render, staticRenderFns } from "./LinkageClass.vue?vue&type=template&id=3102d1d6"
import script from "./LinkageClass.vue?vue&type=script&lang=js"
export * from "./LinkageClass.vue?vue&type=script&lang=js"
import style0 from "./LinkageClass.vue?vue&type=style&index=0&id=3102d1d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports